<div class="modal-header">
	@if (accountHasCompanies()) {
		<button class="close" (click)="modalRef.hide()">&times;</button>
	}
	<h4 class="modal-title">{{ modalTitle }}</h4>
</div>

<app-component-loader [isLoading]="!state.value">
	<!-- WELCOME -->
	@if (state.value === 'welcome') {
		<div class="modal-footer">
			<!-- WELCOME -->
			@if (state.value === 'welcome') {
				<div class="welcome">
					<p class="mt-4">
						Welcome to InfoDocs company secretarial software.<br />
						Please take a moment to tell us a little about yourself.
					</p>
					<img src="assets/img/company-setup.png" style="width: 75%" />
					<button class="btn btn-primary welcome-start" style="margin-top: 5px" (click)="continueFromWelcome()">
						Start
					</button>
				</div>
			}
		</div>
	}

	<!-- ADD COMPANY -->
	<div class="modal-body">
		@if (state.value === 'aboutYou') {
			<app-onboarding-context-form (finished)="onOnboardingFinished()" />
		}

		<!-- SEARCH -->
		@if (
			['search', 'loading', 'companyResults', 'companyResultsError', 'directorResults', 'directorPreview'].includes(
				state.value
			)
		) {
			<form class="form-group" #searchForm="ngForm" (ngSubmit)="search(searchOption, searchQuery)">
				<!-- SEARCH OPTIONS -->
				<div class="d-flex gap-3 mb-3">
					<label class="d-flex align-items-center gap-2">
						<input
							type="radio"
							id="companySearchRadioButton"
							[(ngModel)]="searchOption"
							[ngModelOptions]="{ standalone: true }"
							(ngModelChange)="resetSearch(searchOption)"
							[value]="'company'"
						/>
						Company Search
					</label>
					<label class="d-flex align-items-center gap-2 director-search">
						<input
							type="radio"
							id="directorSearchRadioButton"
							[(ngModel)]="searchOption"
							[ngModelOptions]="{ standalone: true }"
							(ngModelChange)="resetSearch(searchOption)"
							[value]="'director'"
						/>
						Director Search
					</label>
				</div>

				<!-- SEARCH INPUT -->
				<div class="search-input-table">
					<div class="search-input">
						<input
							type="text"
							class="form-control director-search-input"
							[(ngModel)]="searchQuery"
							[ngModelOptions]="{ standalone: true }"
							(ngModelChange)="onSearchQueryChange($event)"
							placeholder="{{ searchPlaceholder() }}"
							required
						/>
					</div>
					<app-search-button [isBusy]="state.value === 'loading'"></app-search-button>
				</div>
			</form>

			@if (directorIdValidationError()) {
				<alert type="danger" class="mt-3 director-search-validation-error">
					{{ directorIdValidationError() }}
				</alert>
			}

			@if (searchErrorMessage()) {
				<alert type="danger" class="mt-3">{{ searchErrorMessage() }}</alert>
			}
		}

		<!-- NEW COMPANY REGISTRATION -->
		@if (state.value === 'search') {
			<div class="form-group">
				<button
					class="btn btn-outline-primary add-company-btn new-company-registration"
					(click)="openAddNewCompanyModal()"
				>
					<app-icon [icon]="faLandmarkIcon" />
					New Registration
				</button>
				<button class="btn btn-outline-primary add-company-btn manual-add" (click)="openManualAddCompanyModal()">
					<app-icon [icon]="penToSquareIcon" />
					Manual Add
				</button>
				@if (hasArchivedCompanies()) {
					<button class="btn btn-outline-primary add-company-btn archives" (click)="goToArchives()">
						<app-icon [icon]="faBoxArchiveIcon" />
						Archives
					</button>
				}
			</div>
		}

		<!-- ARCHIVES -->
		@if (state.value === 'archives') {
			<app-archived-companies-table (back)="goBackFromArchives()" (viewArchive)="previewArchive($event)" />
		}

		<!-- COMPANY SEARCH RESULTS -->
		@if (['companyResults', 'companyResultsError'].includes(state.value)) {
			<div>
				@if (state.value === 'companyResultsError') {
					<alert type="danger"> We couldn't load the company details right now. Please try again later. </alert>
				}
				<table class="table table-hover">
					<thead>
						<tr>
							<th>Company Name</th>
							<th>Registration Number</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<!-- DataConfirm TODO: merge with search-page -->
						@for (company of companyResults(); track company.CompanyInformation.CompanyRegistrationNumber) {
							<tr
								(click)="previewCompany(company)"
								(mouseenter)="toggleFolderOpen(true, company.CompanyInformation.CompanyRegistrationNumber)"
								(mouseleave)="toggleFolderOpen(false, null)"
							>
								<!-- SearchWorks -->
								<!-- <tr *ngFor="let company of companyResults | slice: 0:10" (click)="addCompanyV2(company)"> -->
								<td>
									{{ company.CompanyInformation.CompanyName }}
									@if (
										company.CompanyInformation.CompanyStatus === 'DEREGISTRATION PROCESS' ||
										company.CompanyInformation.CompanyStatus === 'AR FINAL DEREGISTRATION' ||
										company.CompanyInformation.CompanyStatus === 'AR Final deregistration'
									) {
										<app-icon
											[icon]="faExclamationTriangleIcon"
											class="fas fa-exclamation-triangle"
											style="color: #ecaa38"
											title="Warning: This company is in deregistration."
										/>
									}
									@if (company.CompanyInformation.CompanyStatus === 'BUSINESS RESCUE') {
										<app-icon
											[icon]="faExclamationTriangleIcon"
											class="fas fa-exclamation-triangle"
											style="color: #ecaa38"
											title="Warning: This company is in business rescue."
										/>
									}
									@if (company.CompanyInformation.CompanyStatus === 'DEREGISTRATION FINAL') {
										<app-icon
											[icon]="faExclamationTriangleIcon"
											class="fas fa-exclamation-triangle"
											style="color: #c03228"
											title="Please note: This company has been deregistered."
										/>
									}
									@if (company.CompanyInformation.CompanyStatus === 'CONVERSION CO/CC OR CC/CO') {
										<app-icon
											[icon]="faExclamationTriangleIcon"
											class="fas fa-exclamation-triangle"
											style="color: #c03228"
											title="Please note: This company has been converted."
										/>
									}
								</td>
								<td>
									{{ company.CompanyInformation.CompanyRegistrationNumber }}
									@if (company.CompanyExists === 'Archived') {
										<app-archived-badge />
									}
								</td>
								<td>
									<!-- DataConfirm -->
									@if (company.CompanyExists === 'False') {
										<button type="button" class="dataTableButton" style="width: 25px">
											<app-icon
												[icon]="
													openFolder() && hoveredRowId() === company.CompanyInformation.CompanyRegistrationNumber
														? faFolderOpenIcon
														: faFolderIcon
												"
											/>
										</button>
									}

									@if (company.CompanyExists === 'Archived') {
										<a class="add-company-archived-preview" (click)="$event.stopPropagation(); previewCompany(company)">
											Preview
										</a>
									}

									<!-- TODO: [after rebuild] SearchWorks fallback option -->
									<!-- <div *ngIf="company.CompanyInformation.CompanyExists === 'False'"><a (click)="addCompanyV1(company)">Add Company</a></div> -->
									@if (company.CompanyExists === 'Already added') {
										<div>
											<a
												(click)="$event.stopPropagation(); modalService.hide()"
												[routerLink]="['/company', 'profile', company.CompanyInformation.CompanyId]"
											>
												Go To Dashboard
											</a>
										</div>
									}
									@if (company.CompanyExists === 'Request access') {
										<button type="button" class="dataTableButton" style="width: 25px">
											<app-icon
												[icon]="
													openFolder() && hoveredRowId() === company.CompanyInformation.CompanyRegistrationNumber
														? faFolderOpenIcon
														: faFolderIcon
												"
											/>
										</button>
									}
								</td>
							</tr>
						}

						<!-- NO RESULTS -->
						@if (companyResults().length === 0) {
							<tr>
								<td style="width: 41.7%">No results found.</td>
								<td>
									<a class="add-company-btn" (click)="openManualAddCompanyModal()">
										<app-icon [icon]="penToSquareIcon" />
										Manual Add
									</a>
								</td>
								<td></td>
							</tr>
						}
					</tbody>
				</table>
				<!-- TODO: [after rebuild] pagination -->
			</div>
		}

		<!-- DIRECTOR SEARCH RESULTS -->
		@if (state.value === 'directorResults') {
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Director Name</th>
						<th>ID / Passport Number</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					@for (director of directorResults(); track director.DirectorInformation.IdNumber) {
						<tr
							(click)="previewDirectorCompanies(director)"
							class="clickable"
							(mouseenter)="toggleFolderOpen(true, director.DirectorInformation.IdNumber)"
							(mouseleave)="toggleFolderOpen(false, null)"
						>
							<td>
								{{ director.DirectorInformation.FirstNames }}
								{{ director.DirectorInformation.Surname }}
							</td>
							<td>{{ director.DirectorInformation.IdNumber }}</td>
							<td>
								<button type="button" class="dataTableButton" style="width: 25px">
									<app-icon
										[icon]="
											openFolder() && hoveredRowId() === director.DirectorInformation.IdNumber
												? faFolderOpenIcon
												: faFolderIcon
										"
									/>
								</button>
							</td>
						</tr>
					} @empty {
						<!-- NO RESULTS -->
						<td style="width: 41.7%">No results found.</td>
						<td></td>
						<td></td>
					}
				</tbody>
			</table>
		}

		<!-- DIRECTOR COMPANIES PREVIEW -->
		@if (state.value === 'directorPreview') {
			<table class="table table-hover">
				<thead>
					<tr>
						<th>Company Name</th>
						<th>Registration Number</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					@for (company of companyResults(); track company.CompanyInformation.CompanyRegistrationNumber) {
						<tr
							(click)="previewCompany(company)"
							(mouseenter)="toggleFolderOpen(true, company.CompanyInformation.CompanyRegistrationNumber)"
							(mouseleave)="toggleFolderOpen(false, null)"
						>
							<td>{{ company.CompanyInformation.CompanyName }}</td>
							<td>
								{{ company.CompanyInformation.CompanyRegistrationNumber }}
								@if (company.CompanyExists === 'Archived') {
									<app-archived-badge />
								}
							</td>
							<td>
								@if (company.CompanyExists === 'False') {
									<button type="button" class="dataTableButton" style="width: 25px">
										<app-icon
											[icon]="
												openFolder() && hoveredRowId() === company.CompanyInformation.CompanyRegistrationNumber
													? faFolderOpenIcon
													: faFolderIcon
											"
										/>
									</button>
								}
								@if (company.CompanyExists === 'Archived') {
									<a class="add-company-archived-preview" (click)="$event.stopPropagation(); previewCompany(company)">
										Preview
									</a>
								}
								@if (company.CompanyExists === 'Already added') {
									<div>
										<a
											(click)="$event.stopPropagation(); modalService.hide()"
											[routerLink]="['/company', 'profile', company.CompanyInformation.CompanyId]"
										>
											Go To Dashboard
										</a>
									</div>
								}
								@if (company.CompanyExists === 'Request access') {
									<button type="button" class="dataTableButton" style="width: 25px">
										<app-icon
											[icon]="
												openFolder() && hoveredRowId() === company.CompanyInformation.CompanyRegistrationNumber
													? faFolderOpenIcon
													: faFolderIcon
											"
										/>
									</button>
								}
							</td>
						</tr>
					}
				</tbody>
			</table>
		}
	</div>

	@if (state.value === 'aboutYou') {
		<div class="modal-footer about-you-footer">
			<app-submit-button
				formId="onboarding-context-form"
				submitLabel="Next"
				[isDisabled]="onboardingForm()?.isInvalid() ?? true"
				[isBusy]="onboardingForm()?.isSaving() ?? false"
			/>
		</div>
	}
</app-component-loader>
